import { defaultColors, defaultDougnutDatasetOptions, defaultDougnutOptions } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {DoughnutChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'sources_leads',
    resource: 'sources_leads',
    type: 'Doughnut',
    title: {
      id: 'leadsSources',
      label: `${context.$tc('leadResource', 2)} ${context.$tc('lead', 2).toLowerCase()}`,
      style: true,
    },
    data: props => {
      const { data = {}, dimensions = [] } = props
      return {
        labels: dimensions.map(dimension => dimension.label),
        datasets: [
          {
            ...defaultDougnutDatasetOptions,
            backgroundColor: Object.values(defaultColors),
            data: data.values ? data.values.map(value => value.visitors) : [],
          },
        ],
      }
    },
    options: defaultDougnutOptions,
    total: ({ data = {} }) => context.valueParser(data.total),
    colors: Object.values(defaultColors),
    dimensions: ({ data = {}, colors }) =>
      data.keys
        ? data.keys.map((dimension, index) => {
            const key = typeof dimension === 'object' ? dimension.key : dimension
            const label = typeof dimension === 'object' ? dimension.label : dimension
            return {
              id: key,
              label: label,
              value: context.valueParser((data.values.find(value => value.source === key) || {}).visitors),
              icon: '',
              marker: colors[index],
            }
          })
        : [],
    heading: { label: context.$tc('leadResource', 2), style: '', icon: '' },
  }
}
